import { r as registerInstance, h, H as Host, c as createEvent, g as getElement } from './index-16dc7dde.js';
import { a as state, u as updateStorage, g as getSettings, H as HostTypeValues } from './store-9d26336f.js';
import { b as parseJSONString, x as getSiteTypeByURL, y as isBrowser, z as name, A as version } from './utils-15ad90ec.js';
import { p as pesIconSizes, I as ICON_FONT_NAME, L as LOAD_TIMEOUT } from './constants-e9ddcc22.js';
import { i as isZipCodeValid, s as saveZipCodeToStorage, g as getNotificationMessage, a as getCommerceConnectorSettings, n as normalizeZipCodePattern, b as getProductIds, c as getZipCode, d as getBuyOnlineAvailability, e as getPrices, f as startSearch, h as getAllDistributors } from './main-9bda8e90.js';
import { c as classnames } from './index-136476ff.js';
import { c as createCommonjsModule } from './_commonjsHelpers-ba3f0406.js';
import './index-634d378a.js';
import './request.constants-deb285e0.js';
import './send-33ade633.js';
import './analytics-765d4daf.js';
import './utils-913bdf8a.js';
import './lookups-705fb53e.js';
import './tslib.es6-2af8cb53.js';
import './_isIndex-af307327.js';
import './toNumber-5000b45d.js';
import './isObject-33fa1780.js';
import './isSymbol-45bfef0c.js';
import './currency-b61904e0.js';
import './parsers-e38ff6a5.js';
import './locale-86283e50.js';

const appPlaygroundCss = ".app-playground__range-title{font-weight:normal}@media screen and (max-width: 979px){.app-playground__range-title{font-size:18px;line-height:25px}}@media screen and (min-width: 980px){.app-playground__range-title{font-size:22px;line-height:30px}}";

let AppPlayground = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.updateCount = 0;
    this.showPanel = window.location.search.indexOf('hide-panel=true') === -1;
    state.on('set', () => this.updateCount++);
  }
  didCCDialogClosed() {
    this.productIdToShow = undefined;
  }
  get pesApp() {
    return h("slot", { name: "pes-app" });
  }
  get app() {
    switch (state.get('appType')) {
      case 'commerceConnector':
        return (h("div", null, parseJSONString(state.get('products'), []).map((product) => {
          return (h("div", { style: { display: 'flex' } }, h("button", { onClick: () => (this.productIdToShow = product.commercialReference) }, "Show CC for ", product.commercialReference), "-- Its price is ", h("pes-cc-price", { productId: product.commercialReference })));
        }), h("pes-cc-main", { host: state.get('host'), products: parseJSONString(state.get('products'), []), additionalDistributors: parseJSONString(state.get('additionalDistributors'), []), productIdToShow: this.productIdToShow, siteType: state.get('siteType'), localeCode: `${state.get('country')}/${state.get('language')}` })));
      case 'pesCatalog':
      default:
        return this.pesApp;
    }
  }
  render() {
    return (h(Host, { style: { display: 'block', 'padding-bottom': '40px' } }, this.app, this.showPanel && h("pes-settings-control-panel", null)));
  }
};
AppPlayground.style = appPlaygroundCss;

const itemsCss = "@media screen and (min-width: 720px){.cc-items-wrapper{display:flex;flex-direction:row;flex-wrap:wrap}}@media screen and (min-width: 980px){.cc-items-wrapper{margin:-6px}}.cc-item{box-sizing:border-box;display:flex;align-items:center;min-height:91px;text-decoration:none}.cc-item *,.cc-item *::before,.cc-item *::after{box-sizing:inherit}@media screen and (max-width: 719px){.cc-item{border-bottom:1px solid #e7e6e6}:host(:not([dir=\"rtl\"])) .cc-item{padding:8px 0 8px 8px}:host([dir=\"rtl\"]) .cc-item{padding:8px 8px 8px 0}.cc-item:first-child{border-top:1px solid #e7e6e6}}@media screen and (min-width: 720px){.cc-item{display:block;position:relative;height:auto;padding:8px 8px 12px}}@media screen and (min-width: 720px) and (max-width: 980px){.cc-item{flex-grow:0;flex-shrink:0;flex-basis:33.3333333333%;max-width:33.3333333333%;border-bottom:1px solid #e7e6e6}:host(:not([dir=\"rtl\"])) .cc-item{border-right:1px solid #e7e6e6}:host([dir=\"rtl\"]) .cc-item{border-left:1px solid #e7e6e6}.cc-item:nth-child(-n+3){border-top:1px solid #e7e6e6}:host(:not([dir=\"rtl\"])) .cc-item:nth-child(3n+1){border-left:1px solid #e7e6e6}:host([dir=\"rtl\"]) .cc-item:nth-child(3n+1){border-right:1px solid #e7e6e6}}@media screen and (min-width: 720px){.cc-item{display:block;position:relative;height:auto;padding:8px 8px 12px}.cc-item--favorite.cc-item--disable{background-color:#fafafa}.cc-item--favorite:not(.cc-item--disable){border-color:#3dcd58}.cc-item--favorite:not(.cc-item--disable) .cc-item__icon--favorite{color:#3dcd58}.cc-item--favorite .cc-item__icon--favorite{display:block}}@media screen and (min-width: 980px){.cc-item{flex-basis:calc(25% - 12px);max-width:calc(25% - 12px);margin:6px;border:1px solid #e7e6e6}.cc-item:hover{box-shadow:0 7px 15px 0 rgba(51, 51, 51, 0.2)}}.cc-item:focus{outline:2px solid #e7e6e6}.cc-item__icon{color:rgba(51, 51, 51, 0.5)}@media screen and (min-width: 720px){.cc-item__icon{position:absolute;height:16px}}@media screen and (min-width: 980px){.cc-item__icon{display:none}.cc-item:hover .cc-item__icon{display:block}}.cc-item__icon--favorite{align-self:center;background:none;border:none;cursor:pointer}.cc-item__icon--favorite:focus{outline:2px solid #e7e6e6}@media screen and (max-width: 719px){.cc-item__icon--favorite{width:32px;height:32px;padding:8px}.cc-item__icon--favorite:focus{outline:0}}@media screen and (min-width: 720px){.cc-item__icon--favorite{width:16px;height:16px;padding:0;top:10px}:host(:not([dir=\"rtl\"])) .cc-item__icon--favorite{right:11px}:host([dir=\"rtl\"]) .cc-item__icon--favorite{left:11px}}.cc-item__icon--new-window{height:16px;align-self:flex-end}@media screen and (min-width: 720px){.cc-item__icon--new-window{bottom:6px}:host(:not([dir=\"rtl\"])) .cc-item__icon--new-window{left:7px}:host([dir=\"rtl\"]) .cc-item__icon--new-window{right:7px}}.cc-item__logo{width:114px;margin-left:10px;margin-right:10px}@media screen and (min-width: 720px){.cc-item__logo{margin:0 auto;height:70px;text-align:center}}.cc-item__logo img{max-width:114px;max-height:70px;vertical-align:top}.cc-item--favorite.cc-item--disable .cc-item__logo img{opacity:0.5}.cc-item__info{display:flex;flex-direction:column;justify-content:center;align-items:flex-end;font-size:12px;line-height:20px}@media screen and (max-width: 979px){:host(:not([dir=\"rtl\"])) .cc-item__info{margin-left:auto}:host([dir=\"rtl\"]) .cc-item__info{margin-right:auto}}@media screen and (min-width: 720px){.cc-item__info{margin-top:8px;align-items:center}}.cc-item__stock{line-height:20px;padding-left:5px;padding-right:5px;color:#626469;background-color:rgba(98, 100, 105, 0.1)}@media screen and (min-width: 720px){.cc-item__stock{text-align:center}}.cc-item__stock--in{color:#3dcd58;background-color:rgba(61, 205, 88, 0.1)}.cc-item__price{margin-top:8px;color:#626469;font-weight:bold}@media screen and (min-width: 980px){.cc-item__price{flex-grow:1}:host(:not([dir=\"rtl\"])) .cc-item__price{text-align:right}:host([dir=\"rtl\"]) .cc-item__price{text-align:left}}";

let CommerceConnectorItems = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.favoriteRetailIconClick = createEvent(this, "favoriteRetailIconClick", 7);
    this.isFavoriteBlock = false;
    this.favoriteRetailerIconClick = (e, distributor) => {
      e.preventDefault();
      this.favoriteRetailIconClick.emit(distributor);
    };
    this.renderItem = (distributor) => {
      const { isAvailable, priceFormatted, price } = distributor;
      return (h("a", { class: {
          'cc-item': true,
          'cc-item--disable': !isAvailable,
          'cc-item--favorite': this.isFavoriteBlock,
        }, href: distributor.buyUrl, target: "_blank" }, h("div", { class: "cc-item__icon cc-item__icon--new-window" }, h("pes-icon", { size: pesIconSizes.MICRO }, "action_new_window")), h("div", { class: "cc-item__logo" }, h("img", { src: distributor.logoUrl, alt: distributor.name, title: distributor.name })), h("div", { class: "cc-item__info" }, h("div", { class: {
          'cc-item__stock': true,
          'cc-item__stock--in': isAvailable,
        } }, distributor.stockLabel), distributor.showPrice && (h("div", { class: "cc-item__price" }, price ? priceFormatted : this.priceUnavailableLabel))), h("button", { type: "button", class: "cc-item__icon cc-item__icon--favorite", onClick: (e) => {
          this.favoriteRetailerIconClick(e, distributor);
        } }, h("pes-icon", { size: pesIconSizes.MICRO, class: "favorite-icon" }, distributor.isFavorite ? 'star_plain' : 'star_stroke'))));
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("div", { class: { 'cc-items-wrapper': true, 'cc-items-wrapper--favorite': this.isFavoriteBlock } }, this.distributors.map(this.renderItem)));
  }
  get el() { return getElement(this); }
};
CommerceConnectorItems.style = itemsCss;

const FAVORITE_RETAILERS_STORAGE_KEY = 'favorite-retailers';
const getKey = (countryLanguageCode) => `${FAVORITE_RETAILERS_STORAGE_KEY}-${countryLanguageCode}`;
const getFavoritesFromStorage = (countryLanguageCode) => {
  const key = getKey(countryLanguageCode);
  const favorites = parseJSONString(window.localStorage.getItem(key), null);
  return favorites || [];
};
const addFavoritesToStorage = (favorites, countryLanguageCode) => {
  const key = getKey(countryLanguageCode);
  window.localStorage.setItem(key, JSON.stringify(favorites));
};
const getLabelNumber = (label, labels) => {
  const { inStock, outOfStock, notAvailable } = labels;
  switch (label) {
    case inStock:
      return -1;
    case outOfStock:
      return 0;
    case notAvailable:
      return 1;
    default:
      return -2;
  }
};
const sortFavorites = (favorites, labels) => {
  return favorites.sort((a, b) => {
    const aNumber = getLabelNumber(a.stockLabel, labels);
    const bNumber = getLabelNumber(b.stockLabel, labels);
    return aNumber - bNumber;
  });
};
const updateFavoritesInStorage = (distributor, countryLanguageCode) => {
  const storageFavorites = getFavoritesFromStorage(countryLanguageCode);
  const index = storageFavorites.findIndex((favorite) => favorite.id === distributor.id);
  if (index === -1) {
    storageFavorites.push(distributor);
    addFavoritesToStorage(storageFavorites, countryLanguageCode);
  }
  else {
    storageFavorites.splice(index, 1);
    addFavoritesToStorage(storageFavorites, countryLanguageCode);
  }
};
const getFavoritesList = (storageFavorites, distributors, notAvailableLabel) => storageFavorites.map((favorite) => {
  let item = distributors.find((distributor) => distributor.id === favorite.id);
  if (!item) {
    favorite.isAvailable = false;
    favorite.stockLabel = notAvailableLabel;
    favorite.buyUrl = favorite.retailerSite;
    favorite.price = null;
    item = favorite;
  }
  item.isFavorite = true;
  return item;
});
const getSortedFavoritesList = (distributors, countryLanguageCode, labels) => {
  const storageFavorites = getFavoritesFromStorage(countryLanguageCode);
  const favoritesList = getFavoritesList(storageFavorites, distributors, labels.notAvailable);
  return sortFavorites(favoritesList, labels);
};
const getFavoritesIds = (favoritesList) => (favoritesList ? favoritesList.map((favorite) => favorite.id) : []);
const updateFavoriteStatus = (distributors, favoritesIds) => {
  distributors.forEach((distributor) => {
    distributor.isFavorite = favoritesIds.includes(distributor.id);
  });
};

let CommerceConnectorMain = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.ccDialogClosed = createEvent(this, "ccDialogClosed", 7);
    this.channelSightResponse = createEvent(this, "channelSightResponse", 7);
    this.ccBroadcastPrices = createEvent(this, "ccBroadcastPrices", 7);
    this.ccBtnBuyOnlineAvailability = createEvent(this, "ccBtnBuyOnlineAvailability", 7);
    this.ccGetOptionsSucceeded = createEvent(this, "ccGetOptionsSucceeded", 7);
    this.isZipCodeValid = true;
    this.isSearchInputPristine = true;
  }
  dialogCloseHandler() {
    const { useZipCode, searchOnOpen } = this.settings.options;
    this.showValidateMessage = false;
    this.isSearchInputPristine = true;
    this.ccDialogClosed.emit();
    if (useZipCode && !searchOnOpen) {
      this.showContent = false;
    }
  }
  favoriteRetailIconClickHandler(e) {
    const { options: { countryLanguageCode }, } = this.settings;
    updateFavoritesInStorage(e.detail, countryLanguageCode);
    this.initUpdateFavoritesList();
  }
  buyOnlineSearchClickHandler(event) {
    const { options: { zipCodePattern, countryLanguageCode, feedUrl, useZipCode, searchOnOpen, enableEmptyZipCode, }, labels: { inStock, outOfStock }, } = this.settings;
    const value = event.detail;
    this.isZipCodeValid = isZipCodeValid(zipCodePattern, value);
    this.showValidateMessage = !this.isZipCodeValid;
    if (this.isZipCodeValid) {
      if (value !== this.zipCode) {
        this.zipCode = value;
        saveZipCodeToStorage(countryLanguageCode, this.zipCode);
      }
      this.notification = undefined;
      this.productInfo
        && this.initSearch({
          commercialReference: this.productInfo.commercialReference,
          zipCode: this.zipCode,
          feedUrl,
          inStock,
          outOfStock,
          useZipCode,
          searchOnOpen,
          enableEmptyZipCode,
          showContent: true,
          showPrice: this.settings.options.enablePrice,
        });
    }
  }
  buyOnlineSearchInputChangedHandler() {
    this.isSearchInputPristine = false;
  }
  onProductToShowIdChange() {
    if (!this.productIdToShow) {
      return;
    }
    const { options: { zipCodePattern, feedUrl, useZipCode, searchOnOpen, enableEmptyZipCode }, labels: { inStock, outOfStock }, } = this.settings;
    this.isZipCodeValid = isZipCodeValid(zipCodePattern, this.zipCode);
    this.showValidateMessage = !this.isZipCodeValid && !this.isSearchInputPristine;
    if (this.isZipCodeValid) {
      this.notification = undefined;
    }
    this.initSearch({
      commercialReference: this.productIdToShow,
      zipCode: this.zipCode,
      feedUrl,
      inStock,
      outOfStock,
      useZipCode,
      searchOnOpen,
      enableEmptyZipCode,
      showContent: this.settings.options.useZipCode ? this.settings.options.searchOnOpen : true,
      showPrice: this.settings.options.enablePrice,
    }).then(() => {
      this.initUpdateFavoritesList();
    });
  }
  distributorsChangeHandler() {
    this.notification = getNotificationMessage(this.zipCode, Object.keys(this.productsDistributorsInfo).length, this.settings);
  }
  componentWillLoad() {
    var _a;
    (_a = this.siteType) !== null && _a !== void 0 ? _a : (this.siteType = getSiteTypeByURL(this.host));
    getCommerceConnectorSettings(this.host, this.localeCode).then((response) => {
      if (!response)
        return;
      this.ccGetOptionsSucceeded.emit(response.options);
      if (response.options.enableChannelSight) {
        this.settings = response;
        this.showContent = this.settings.options.useZipCode
          ? this.settings.options.searchOnOpen
          : true;
        this.settings.options.zipCodePattern = normalizeZipCodePattern(this.settings.options.zipCodePattern);
        const productIds = getProductIds(this.products);
        const { options: { zipCodePattern, countryLanguageCode, useZipCode, detectZipCode, zipCodeLength, feedUrl, searchOnOpen, enablePrice, priceTemplate, enableEmptyZipCode, }, labels: { inStock, outOfStock, priceFrom: priceFromLabel }, } = this.settings;
        if (useZipCode) {
          this.zipCode = getZipCode({
            countryLanguageCode,
            detect: detectZipCode,
            length: zipCodeLength,
            pattern: zipCodePattern,
          });
        }
        this.initSearch({
          commercialReference: productIds,
          zipCode: this.zipCode,
          feedUrl,
          inStock,
          outOfStock,
          useZipCode,
          searchOnOpen,
          enableEmptyZipCode,
          showContent: false,
          showPrice: enablePrice,
        }).then(() => {
          const buttonsBuyOnlineAvailability = getBuyOnlineAvailability(this.products, this.productsDistributorsInfo);
          this.ccBtnBuyOnlineAvailability.emit(buttonsBuyOnlineAvailability);
          if (enablePrice) {
            const prices = getPrices(this.productsDistributorsInfo, {
              template: priceTemplate,
              locale: countryLanguageCode,
            });
            this.ccBroadcastPrices.emit({ priceFromLabel, prices });
          }
        });
      }
    });
  }
  get productInfo() {
    if (!this.productIdToShow) {
      return;
    }
    return this.products.find((product) => product.commercialReference === this.productIdToShow);
  }
  async initSearch({ commercialReference, zipCode, feedUrl, inStock, outOfStock, useZipCode, searchOnOpen, enableEmptyZipCode, showContent, showPrice, }) {
    const stockLabels = { inStock, outOfStock };
    this.showLoader = true;
    if (!this.zipCode && !enableEmptyZipCode) {
      this.showContent = false;
    }
    else if (useZipCode && !searchOnOpen) {
      this.showContent = showContent;
    }
    else {
      this.showContent = true;
    }
    try {
      const { productsDataFeed, distributorProductsInfo } = await startSearch({
        feedUrl,
        commercialReference,
        zipCode,
        stockLabels,
        showPrice,
        siteType: this.siteType,
      });
      this.channelSightResponse.emit(productsDataFeed);
      this.productsDistributorsInfo = distributorProductsInfo;
    }
    catch (error) {
      this.productsDistributorsInfo = {};
      console.error(error);
    }
    finally {
      this.showLoader = false;
    }
  }
  initUpdateFavoritesList() {
    var _a;
    const { options: { countryLanguageCode, priceTemplate }, labels: { notAvailable, inStock, outOfStock }, } = this.settings;
    const distributors = getAllDistributors((_a = this.productInfo) === null || _a === void 0 ? void 0 : _a.commercialReference, this.productsDistributorsInfo, this.additionalDistributors, { priceLocale: countryLanguageCode, priceTemplate });
    this.favoriteDistributors = getSortedFavoritesList(distributors, countryLanguageCode, {
      notAvailable,
      inStock,
      outOfStock,
    });
  }
  render() {
    var _a;
    if (!this.settings || !isBrowser()) {
      return null;
    }
    const { priceTemplate, countryLanguageCode: priceLocale } = this.settings.options;
    const favoritesIds = getFavoritesIds(this.favoriteDistributors);
    const distributors = getAllDistributors((_a = this.productInfo) === null || _a === void 0 ? void 0 : _a.commercialReference, this.productsDistributorsInfo, this.additionalDistributors, { priceTemplate, priceLocale });
    updateFavoriteStatus(distributors, favoritesIds);
    return (h("pes-cc-main-view", { isOpen: !!this.productIdToShow, header: this.settings.labels.modalHeader, product: this.productInfo, notification: this.notification, isContentVisible: this.showContent, labels: this.settings.labels, distributors: distributors, favorites: this.favoriteDistributors, showLoader: this.showLoader, showSearch: !!this.productIdToShow && this.settings.options.useZipCode, searchHeading: this.settings.labels.searchTitle, searchPlaceholder: this.settings.labels.searchPlaceholder, searchMaxLength: this.settings.options.zipCodeLength, searchButtonLabel: this.settings.labels.searchButton, searchMessage: this.settings.messages.invalidZipCode, searchShowValidateMessage: this.settings.options.useZipCode && this.showValidateMessage, searchValue: this.settings.options.useZipCode ? this.zipCode : undefined }));
  }
  static get watchers() { return {
    "productIdToShow": ["onProductToShowIdChange"],
    "productsDistributorsInfo": ["distributorsChangeHandler"]
  }; }
};

const mainCss = ".cc-wrapper{text-align:initial}.cc-header{position:-webkit-sticky;position:sticky;display:flex;flex-direction:column;padding:16px 16px 24px}@media screen and (min-width: 980px){.cc-header--content-scrollable::after{content:\"\";position:absolute;right:0;left:0;bottom:-10px;height:10px;background:linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0));opacity:0;pointer-events:none}}@media screen and (min-width: 980px){.cc-header--content-scrolled::after{opacity:1}}@media screen and (min-width: 980px){.cc-header{position:-webkit-sticky;position:sticky;top:0;padding:24px 36px;flex-direction:row;z-index:1000;background-color:#ffffff}}.cc-header__info-wrapper{display:flex;color:#333333}@media screen and (min-width: 980px){.cc-header__info-wrapper{width:50%;flex-basis:50%}:host(:not([dir=\"rtl\"])) .cc-header__info-wrapper{margin-right:6px}:host([dir=\"rtl\"]) .cc-header__info-wrapper{margin-left:6px}}@media screen and (min-width: 980px){:host(:not([dir=\"rtl\"])) .cc-header__info-wrapper [dir=rtl]{margin-left:24px;margin-right:0px}:host([dir=\"rtl\"]) .cc-header__info-wrapper [dir=rtl]{margin-right:24px;margin-left:0px}}.cc-header__info-title{margin-bottom:4px;font-size:14px;line-height:24px;font-weight:bold}@media screen and (min-width: 980px){.cc-header__info-title{font-size:16px}}.cc-header__info-description{font-size:12px;line-height:16px}@media screen and (min-width: 980px){.cc-header__info-description{font-size:14px;line-height:20px}}:host(:not([dir=\"rtl\"])) .cc-header__img{margin-right:10px}:host([dir=\"rtl\"]) .cc-header__img{margin-left:10px}@media screen and (min-width: 980px){:host(:not([dir=\"rtl\"])) .cc-header__img{margin-right:24px}:host([dir=\"rtl\"]) .cc-header__img{margin-left:24px}}.cc-header__img img{width:70px;height:70px}@media screen and (min-width: 980px){.cc-header__search-slot{width:50%;flex-basis:50%}:host(:not([dir=\"rtl\"])) .cc-header__search-slot{margin-left:6px}:host([dir=\"rtl\"]) .cc-header__search-slot{margin-right:6px}}@media screen and (min-width: 980px){.cc-content__notification-wrapper{padding:0 36px 16px}}.cc-content__result-title{padding:8px 16px;font-size:16px;line-height:24px;font-weight:bold;color:#333333}@media screen and (min-width: 980px){.cc-content__result-title{padding:8px 0}}.cc-content__result-title:not(:first-child){padding-top:36px}@media screen and (min-width: 980px){.cc-content__result-title:not(:first-child){padding-top:24px}}@media screen and (min-width: 980px){.cc-content__result-wrapper{padding:0 36px 36px}}.cc-content__result--no-result{padding:24px 36px 48px}";

let CommerceConnectorView = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.contentScrolled = false;
    this.onDialogContentScroll = () => {
      this.contentScrolled = this.dialogContent.scrollTop > 0;
    };
    this.renderContent = (distributors, favorites, labels) => {
      const { noSearchResults, allRetailers, favoriteRetailers, priceUnavailable } = labels;
      const isFavorites = favorites && !!favorites.length;
      if (!distributors.length) {
        return h("pes-cc-no-result", { label: noSearchResults });
      }
      return (h("div", null, isFavorites && h("div", { class: "cc-content__result-title" }, favoriteRetailers), isFavorites && (h("pes-cc-items", { isFavoriteBlock: true, distributors: favorites, priceUnavailableLabel: priceUnavailable })), isFavorites && h("div", { class: "cc-content__result-title" }, allRetailers), h("pes-cc-items", { distributors: distributors, priceUnavailableLabel: priceUnavailable })));
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentDidLoad() {
    this.dialogContent.addEventListener('scroll', this.onDialogContentScroll);
  }
  render() {
    return (h("div", { class: "cc-wrapper" }, h("se-dialog", { size: "xlarge", color: "primary", open: this.isOpen, "page-scroll": "false" }, h("se-dialog-header", { "close-icon": "true", option: "indent" }, this.header), h("se-dialog-content", { option: "fill", ref: (el) => (this.dialogContent = el) }, h("div", { class: "cc-body" }, this.product && (h("div", { class: {
        'cc-header': true,
        'cc-header--content-scrollable': this.isContentVisible,
        'cc-header--content-scrolled': this.contentScrolled,
      } }, h("div", { class: "cc-header__info-wrapper" }, h("div", { class: "cc-header__img", dir: document.documentElement.dir }, h("img", { src: this.product.imgUrl, alt: this.product.imgAlt })), h("div", { class: "cc-header__info" }, h("div", { class: "cc-header__info-title" }, this.product.commercialReference), h("div", { class: "cc-header__info-description" }, this.product.description))), h("div", { class: "cc-header__search-slot" }, this.showSearch && (h("pes-cc-search", { heading: this.searchHeading, placeholder: this.searchPlaceholder, maxLength: this.searchMaxLength, buttonLabel: this.searchButtonLabel, message: this.searchMessage, showValidateMessage: this.searchShowValidateMessage, value: this.searchValue }))))), this.isContentVisible && (h("div", { class: "cc-content" }, this.notification && (h("div", { class: "cc-content__notification-wrapper" }, h("pes-notification", { label: this.notification, icon: "general_danger_wired" }))), h("div", { class: {
        'cc-content__result-wrapper': true,
        'cc-content__result-wrapper--no-result': !this.distributors.length,
      } }, this.showLoader ? (h("pes-preloader", null)) : (this.renderContent(this.distributors, this.favorites, this.labels))))))))));
  }
  get el() { return getElement(this); }
};
CommerceConnectorView.style = mainCss;

const noResultCss = ".cc-no-result__icon{width:64px;margin:0 auto 13px;color:rgba(51, 51, 51, 0.5)}.cc-no-result__label{font-size:12px;line-height:18px;font-weight:bold;text-align:center;color:#626469}";

let CommerceConnectorNoResult = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h("div", { class: "cc-no-result" }, h("div", { class: "cc-no-result__icon" }, h("pes-icon", { size: pesIconSizes.XLARGE }, "action_ban")), h("div", { class: "cc-no-result__label" }, this.label)));
  }
};
CommerceConnectorNoResult.style = noResultCss;

const priceCss = ".pes-cc-price{padding:0;margin:6px 0;font-weight:bold;color:#333333;font-size:18px;line-height:25px}@media screen and (min-width: 980px){.pes-cc-price{font-size:16px}:host(:not([dir=\"rtl\"])) .pes-cc-price{text-align:left}:host([dir=\"rtl\"]) .pes-cc-price{text-align:right}}.pes-cc-price__label{font-size:14px;line-height:1.4285714286;display:block;margin-bottom:10px;font-weight:normal}";

let CommerceConnectorPrice = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  priceBroadcastHandler(event) {
    const { detail: { prices, priceFromLabel }, } = event;
    if (this.productId in prices) {
      this.price = prices[this.productId];
      this.priceFromLabel = priceFromLabel;
    }
  }
  render() {
    if (!this.price) {
      return;
    }
    return h("div", { class: "pes-cc-price" }, h("span", { class: "pes-cc-price__label" }, this.priceFromLabel), h("span", null, this.price));
  }
};
CommerceConnectorPrice.style = priceCss;

function getInputValue(event) {
  if (event.target.id === 'ccSearchInput' && event.key === 'Enter') {
    return event.target.value;
  }
  if (event.target.id === 'ccSearchButton') {
    return event.target.previousSibling.value;
  }
}

const searchCss = ".cc-header__search{position:relative;display:flex;height:30px;margin-top:4px}.cc-header__search pes-icon{position:absolute;margin-top:6px}:host(:not([dir=\"rtl\"])) .cc-header__search pes-icon{margin-left:8px}:host([dir=\"rtl\"]) .cc-header__search pes-icon{margin-right:8px}.cc-header__search-wrapper{margin-top:24px;font-size:14px;line-height:20px;color:#626469}@media screen and (min-width: 980px){.cc-header__search-wrapper{margin-top:8px}}.cc-header__search-input{box-sizing:border-box;height:100%;flex-grow:1;border-radius:0;border:1px solid #9fa0a4;color:#9fa0a4;outline:none}:host(:not([dir=\"rtl\"])) .cc-header__search-input{padding-left:30px}:host([dir=\"rtl\"]) .cc-header__search-input{padding-right:30px}.cc-header__search-input:focus{color:#333333}.cc-header__search-input--error{border-color:#b10043}.cc-header__search-input--error:focus{border-color:#9fa0a4}.cc-header__search-button{height:100%;padding:5px 15px;border:0;border-radius:0;background-color:#42b4e6;font-size:12px;line-height:20px;color:#ffffff}.cc-header__search-button:active{background-color:#3a738c}.cc-header__search-button:focus{outline:1px solid #3a738c}.cc-header__search-message{margin-top:4px;font-size:12px;line-height:15px;color:#b10043}";

let CommerceConnectorSearch = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.buyOnlineSearchClick = createEvent(this, "buyOnlineSearchClick", 7);
    this.buyOnlineSearchInputChanged = createEvent(this, "buyOnlineSearchInputChanged", 7);
    this.handleSubmit = (event) => {
      const value = getInputValue(event);
      this.buyOnlineSearchClick.emit(value);
    };
    this.handleInputValueChange = () => {
      this.buyOnlineSearchInputChanged.emit();
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("div", { class: "cc-header__search-wrapper" }, h("div", { class: "cc-header__search-heading" }, this.heading), h("div", { class: "cc-header__search" }, h("pes-icon", { size: "micro" }, "map_location"), h("input", { id: "ccSearchInput", type: "text", class: {
        'cc-header__search-input': true,
        'cc-header__search-input--error': this.showValidateMessage,
      }, placeholder: this.placeholder, maxLength: this.maxLength, value: this.value, onKeyUp: this.handleInputValueChange }), h("button", { id: "ccSearchButton", class: "cc-header__search-button", onClick: this.handleSubmit }, this.buttonLabel)), this.showValidateMessage && h("div", { class: "cc-header__search-message" }, this.message)));
  }
  get el() { return getElement(this); }
};
CommerceConnectorSearch.style = searchCss;

var fontfaceobserver_standalone = createCommonjsModule(function (module) {
/* Font Face Observer v2.1.0 - © Bram Stein. License: BSD-3-Clause */(function(){function l(a,b){document.addEventListener?a.addEventListener("scroll",b,!1):a.attachEvent("scroll",b);}function m(a){document.body?a():document.addEventListener?document.addEventListener("DOMContentLoaded",function c(){document.removeEventListener("DOMContentLoaded",c);a();}):document.attachEvent("onreadystatechange",function k(){if("interactive"==document.readyState||"complete"==document.readyState)document.detachEvent("onreadystatechange",k),a();});}function t(a){this.a=document.createElement("div");this.a.setAttribute("aria-hidden","true");this.a.appendChild(document.createTextNode(a));this.b=document.createElement("span");this.c=document.createElement("span");this.h=document.createElement("span");this.f=document.createElement("span");this.g=-1;this.b.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";this.c.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";
this.f.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";this.h.style.cssText="display:inline-block;width:200%;height:200%;font-size:16px;max-width:none;";this.b.appendChild(this.h);this.c.appendChild(this.f);this.a.appendChild(this.b);this.a.appendChild(this.c);}
function u(a,b){a.a.style.cssText="max-width:none;min-width:20px;min-height:20px;display:inline-block;overflow:hidden;position:absolute;width:auto;margin:0;padding:0;top:-999px;white-space:nowrap;font-synthesis:none;font:"+b+";";}function z(a){var b=a.a.offsetWidth,c=b+100;a.f.style.width=c+"px";a.c.scrollLeft=c;a.b.scrollLeft=a.b.scrollWidth+100;return a.g!==b?(a.g=b,!0):!1}function A(a,b){function c(){var a=k;z(a)&&a.a.parentNode&&b(a.g);}var k=a;l(a.b,c);l(a.c,c);z(a);}function B(a,b){var c=b||{};this.family=a;this.style=c.style||"normal";this.weight=c.weight||"normal";this.stretch=c.stretch||"normal";}var C=null,D=null,E=null,F=null;function G(){if(null===D)if(J()&&/Apple/.test(window.navigator.vendor)){var a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))(?:\.([0-9]+))/.exec(window.navigator.userAgent);D=!!a&&603>parseInt(a[1],10);}else D=!1;return D}function J(){null===F&&(F=!!document.fonts);return F}
function K(){if(null===E){var a=document.createElement("div");try{a.style.font="condensed 100px sans-serif";}catch(b){}E=""!==a.style.font;}return E}function L(a,b){return [a.style,a.weight,K()?a.stretch:"","100px",b].join(" ")}
B.prototype.load=function(a,b){var c=this,k=a||"BESbswy",r=0,n=b||3E3,H=(new Date).getTime();return new Promise(function(a,b){if(J()&&!G()){var M=new Promise(function(a,b){function e(){(new Date).getTime()-H>=n?b(Error(""+n+"ms timeout exceeded")):document.fonts.load(L(c,'"'+c.family+'"'),k).then(function(c){1<=c.length?a():setTimeout(e,25);},b);}e();}),N=new Promise(function(a,c){r=setTimeout(function(){c(Error(""+n+"ms timeout exceeded"));},n);});Promise.race([N,M]).then(function(){clearTimeout(r);a(c);},
b);}else m(function(){function v(){var b;if(b=-1!=f&&-1!=g||-1!=f&&-1!=h||-1!=g&&-1!=h)(b=f!=g&&f!=h&&g!=h)||(null===C&&(b=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent),C=!!b&&(536>parseInt(b[1],10)||536===parseInt(b[1],10)&&11>=parseInt(b[2],10))),b=C&&(f==w&&g==w&&h==w||f==x&&g==x&&h==x||f==y&&g==y&&h==y)),b=!b;b&&(d.parentNode&&d.parentNode.removeChild(d),clearTimeout(r),a(c));}function I(){if((new Date).getTime()-H>=n)d.parentNode&&d.parentNode.removeChild(d),b(Error(""+
n+"ms timeout exceeded"));else {var a=document.hidden;if(!0===a||void 0===a)f=e.a.offsetWidth,g=p.a.offsetWidth,h=q.a.offsetWidth,v();r=setTimeout(I,50);}}var e=new t(k),p=new t(k),q=new t(k),f=-1,g=-1,h=-1,w=-1,x=-1,y=-1,d=document.createElement("div");d.dir="ltr";u(e,L(c,"sans-serif"));u(p,L(c,"serif"));u(q,L(c,"monospace"));d.appendChild(e.a);d.appendChild(p.a);d.appendChild(q.a);document.body.appendChild(d);w=e.a.offsetWidth;x=p.a.offsetWidth;y=q.a.offsetWidth;I();A(e,function(a){f=a;v();});u(e,
L(c,'"'+c.family+'",sans-serif'));A(p,function(a){g=a;v();});u(p,L(c,'"'+c.family+'",serif'));A(q,function(a){h=a;v();});u(q,L(c,'"'+c.family+'",monospace'));});})};module.exports=B;}());
});

const iconCss = ":host{display:inline-block}.icon{display:flex;opacity:0;pointer-events:none}.icon--loaded{opacity:1}.icon__element{pointer-events:none}.icon--nano{width:14px;height:14px;font-size:14px;line-height:14px}.icon--micro{width:18px;height:18px;font-size:18px;line-height:18px}.icon--small{width:24px;height:24px;font-size:24px;line-height:24px}.icon--medium{width:32px;height:32px;font-size:32px;line-height:32px}.icon--large{width:52px;height:52px;font-size:52px;line-height:52px}.icon--xlarge{width:62px;height:62px;font-size:62px;line-height:62px}";

let IconComponent = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.size = pesIconSizes.SMALL;
    this.fontLoaded = false;
    this.handleFontFaceLoaded = () => {
      this.fontLoaded = true;
    };
  }
  componentWillLoad() {
    new fontfaceobserver_standalone(ICON_FONT_NAME)
      .load(null, LOAD_TIMEOUT)
      .then(this.handleFontFaceLoaded, this.handleFontFaceLoaded);
  }
  render() {
    const iconClass = classnames({
      icon: true,
      [`icon--${this.size}`]: true,
      'icon--loaded': this.fontLoaded,
    });
    return (h("span", { class: iconClass }, h("se-icon", { class: "icon__element", option: this.option, size: this.size, color: this.color, mirror: this.mirror, style: this.customStyle }, h("slot", null))));
  }
  get el() { return getElement(this); }
};
IconComponent.style = iconCss;

const notificationCss = ".notification{display:flex;padding:16px;font-size:12px;line-height:18px;color:#333333}@media screen and (min-width: 980px){.notification{padding:18px}}:host(:not([dir=\"rtl\"])) .notification__icon{margin-right:16px}:host([dir=\"rtl\"]) .notification__icon{margin-left:16px}@media screen and (min-width: 980px){:host(:not([dir=\"rtl\"])) .notification__icon{margin-right:18px}:host([dir=\"rtl\"]) .notification__icon{margin-left:18px}}.notification__text{flex:1 0 0px}.alert{background-color:rgba(228, 127, 0, 0.1)}.alert .notification__icon{color:#e47f00}";

let Notification = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.colorScheme = 'alert';
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("div", { class: `notification ${this.colorScheme}` }, this.icon ? (h("div", { class: "notification__icon" }, h("pes-icon", null, this.icon))) : null, this.label ? h("div", { class: "notification__text" }, this.label) : null));
  }
  get el() { return getElement(this); }
};
Notification.style = notificationCss;

const preloaderCss = ".pes-preloader{animation:spin 1s linear infinite;background-image:url(\"data:image/svg+xml,%3Csvg width='54' height='54' viewBox='0 0 54 54' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M46 27C46 37.4934 37.4934 46 27 46V54C41.9117 54 54 41.9117 54 27C54 12.0883 41.9117 0 27 0V8C37.4934 8 46 16.5066 46 27Z' fill='%2342B4E6' /%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M27 46C16.5066 46 8 37.4934 8 27C8 16.5066 16.5066 8 27 8V0C12.0883 0 0 12.0883 0 27C0 41.9117 12.0883 54 27 54V46Z' fill='%23E7E6E6' /%3E%3C/svg%3E\");background-position:center;background-repeat:no-repeat;height:100%;margin:0 auto;min-height:60px;width:60px;padding:0}@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}";

let Preloader = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return h("div", { class: "pes-preloader" });
  }
};
Preloader.style = preloaderCss;

const pesRadioCss = ":host{box-sizing:border-box}:host *,:host *::before,:host *::after{box-sizing:inherit}:host(.radio--column){display:flex;flex-direction:column}";

let PesRadio = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.pesRadioChange = createEvent(this, "pesRadioChange", 1);
    this.items = [];
  }
  onChange(e) {
    this.pesRadioChange.emit(e.detail);
  }
  render() {
    return (h(Host, null, this.items.map((item) => {
      var _a, _b;
      return (h("pes-radio-button", { onButtonChange: (e) => this.onChange(e), value: item.value, text: item.text, name: this.groupId, checked: ((_a = this.selectedValue) === null || _a === void 0 ? void 0 : _a.toString()) === ((_b = item.value) === null || _b === void 0 ? void 0 : _b.toString()) }));
    })));
  }
};
PesRadio.style = pesRadioCss;

const pesRadioButtonCss = ":host{white-space:nowrap}";

let PesRadioGroup = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.buttonChange = createEvent(this, "buttonChange", 1);
    this.checked = false;
  }
  onChange() {
    this.buttonChange.emit(this.value);
  }
  get id() {
    return `pes-radio-button-${this.name}-${this.value}`;
  }
  render() {
    return (h(Host, null, h("input", { onChange: () => this.onChange(), type: "radio", id: this.id, name: this.name, value: this.value, checked: this.checked }), h("label", { htmlFor: this.id }, this.text)));
  }
};
PesRadioGroup.style = pesRadioButtonCss;

const PES_SPRYKER_ENDPOINTS = [
  'https://glue.pes-sqe.se.com',
  'https://glue.pes-ppr.se.com',
];

const controlPanelCss = "@charset \"UTF-8\";:host{direction:ltr;width:calc(100% - 22px);max-width:600px;display:flex;flex-direction:column;position:fixed;top:calc(100vh - 41px);border-top-left-radius:40px;border-top-right-radius:40px;border:1px solid #333333;border-bottom:none;padding:0 10px 10px;z-index:1000}@media screen and (min-width: 980px){:host{left:calc(50vw - 300px) }}:host(.open){top:auto;bottom:0;background:#eee}h2{text-align:center;margin:0;line-height:40px;cursor:pointer}label,summary{min-width:100px;display:inline-block}section:not(.settings--outline):not(:last-child),details:not(:last-child){padding:1px 0}details{display:flex;flex-direction:column}summary{cursor:pointer}details>summary::before,details>summary::after{content:\"▼▼▼\"}details[open]>summary::before,details[open]>summary::after{content:\"▲▲▲\"}@media screen and (min-width: 980px){section:not(.settings--wide),details:not(.settings--wide){width:50%}}@media screen and (min-width: 980px){section.settings--extra section:not(.settings--wide){width:100%}}textarea{width:100%;height:300px}textarea,input,select{font-size:16px}.input--wide{width:100%}.version--section{margin-bottom:6px}.settings--extra{display:grid;width:100%;grid-template-columns:50% 50%;align-items:start}.settings--outline{box-sizing:border-box;padding:10px;margin:10px 0;outline:1px solid #626469}.settings--outline+.settings--outline{margin-top:0}";

let ControlPanel = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.isOpen = false;
    this.showCustomPrice = false;
    this.showCatalogPrice = true;
    this.showBreadcrumbs = false;
    this.showBuyOnline = true;
    this.showLinks = true;
    this.showCompare = false;
    this.showFaq = false;
    this.showRecentlyViewed = false;
    this.showDocuments = true;
    this.importedSettings = '';
    this.importExpanded = false;
    this.searchParams = {};
    this.ddcAppSource = '';
    this.ddcAllProductsUrl = '';
    this.endpointUrls = [
      'https://www.se.com/',
      'https://www.schneider-electric.',
      'http://www-prdpes.ecom.schneider-electric.com/',
      'https://www-pre.se.com/',
      'http://www-pre.schneider-electric.',
      'http://www-preprdpes.ecom.schneider-electric.com/',
      'https://www-sqe.se.com/',
      'http://www-sqe.schneider-electric.',
      'http://www-sqepes.ecom.schneider-electric.com/',
      'http://www-oosqepes.ecom.schneider-electric.com/',
      'http://www-intpes.ecom.schneider-electric.com/',
    ];
    this.pesSprykerHosts = PES_SPRYKER_ENDPOINTS;
    this.appTypes = [
      { text: 'PES Business Service', value: 'pesCatalog' },
      { text: 'Commerce Connector', value: 'commerceConnector' },
    ];
    this.pages = [
      { text: 'All products', value: '' },
      { text: 'Category', value: 'category' },
      { text: 'Subcategory', value: 'subcategory' },
      { text: 'Range (prp)', value: 'range' },
      { text: 'Product (pdp)', value: 'product' },
    ];
    this.dirTypes = [
      { text: 'ltr', value: 'ltr' },
      { text: 'rtl', value: 'rtl' },
      { text: 'auto', value: 'auto' },
    ];
    this.hostTypes = [
      { text: 'Atg', value: 'Atg' },
      { text: 'Spryker', value: 'Spryker' },
    ];
    this.useS3Types = [
      { text: 'Yes', value: 'Yes' },
      { text: 'No', value: 'No' },
    ];
    this.onImport = () => {
      if (this.importedSettings) {
        updateStorage(this.importedSettings);
        window.location.reload();
      }
    };
    this.onImportChange = (e) => {
      this.importedSettings = e.target.value;
    };
    this.onImportToggle = () => {
      this.importExpanded = !this.importExpanded;
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  onSettingsChange(e, setting, castCallback) {
    console.log(JSON.stringify({ setting, value: e.detail }));
    if (e.detail !== undefined) {
      const value = e.detail.toString();
      state.set(setting, castCallback ? castCallback(value) : value);
    }
    else if (e.target.type === 'checkbox') {
      const value = e.target && e.target.checked;
      state.set(setting, castCallback ? castCallback(value) : value);
    }
    else {
      const value = e.target && e.target.value;
      state.set(setting, castCallback ? castCallback(value) : value);
    }
  }
  toggleOpen() {
    this.isOpen = !this.isOpen;
  }
  render() {
    return (h(Host, { class: this.isOpen ? 'open' : '' }, h("h2", { onClick: () => this.toggleOpen() }, "Testing control panel"), h("section", { class: "settings--wide version--section" }, h("label", null, "Package-version: ", name, " - ", version)), h("section", { class: "settings--wide" }, h("label", null, "Application type:"), h("pes-radio", { "group-id": "appType", items: this.appTypes, onPesRadioChange: (e) => this.onSettingsChange(e, 'appType'), "selected-value": state.get('appType') })), h("section", { class: "settings--wide" }, h("label", null, "Use S3 locales:"), h("pes-radio", { "group-id": "useS3", items: this.useS3Types, onPesRadioChange: (e) => this.onSettingsChange(e, 'useS3', (value) => value === 'Yes'), "selected-value": state.get('useS3') ? 'Yes' : 'No' })), !state.get('useS3') && (h("section", { class: "settings--wide" }, h("label", null, "Host type:"), h("pes-radio", { "group-id": "hostType", items: this.hostTypes, onPesRadioChange: (e) => this.onSettingsChange(e, 'hostType'), "selected-value": state.get('hostType') }))), h("section", { class: "settings--wide" }, h("label", null, "Host (clear input and click to see all options):"), h("input", { class: "input--wide", type: "text", list: "url", onChange: (e) => this.onSettingsChange(e, 'host'), value: state.get('host') }), h("datalist", { id: "url" }, state.get('hostType') === HostTypeValues.Spryker
      && this.pesSprykerHosts.map((url, index) => h("option", { key: index }, url)), state.get('hostType') === HostTypeValues.Atg
      && this.endpointUrls.map((url, index) => h("option", { key: index }, url)))), h("section", { class: "settings--wide settings--extra" }, state.get('appType') === 'pesCatalog' && [
      h("section", null, h("input", { type: "checkbox", onChange: (e) => this.onSettingsChange(e, 'usePesRouter'), checked: state.get('usePesRouter') }), h("label", null, "Use router parser")),
    ], state.get('appType') === 'pesCatalog' && state.get('usePesRouter') && (h("section", null, h("label", null, "Routing type:"), h("pes-radio", { "group-id": "routing-type", items: [
        { text: 'path', value: 'path' },
        { text: 'hash', value: 'hash' },
      ], onPesRadioChange: (e) => this.onSettingsChange(e, 'pesRouterNavigation'), "selected-value": state.get('pesRouterNavigation') })))), h("section", { class: "settings--wide" }, state.get('appType') === 'pesCatalog' && [
      !state.get('usePesRouter') && [
        h("section", { class: "settings--wide settings--extra settings--outline" }, h("details", { class: "settings--wide" }, h("summary", null, "Page (click to expand)"), h("pes-radio", { class: "radio--column", "group-id": "page", items: this.pages, onPesRadioChange: (e) => this.onSettingsChange(e, 'page'), "selected-value": state.get('page') })), h("section", { class: "settings--wide" }, h("section", { class: "settings--wide" }, h("label", null, "Page Id"), h("input", { type: "text", onChange: (e) => this.onSettingsChange(e, 'pageId'), value: state.get('pageId') })), h("section", { class: "settings--wide" }, h("label", null, "Search Params"), h("input", { type: "text", onChange: (e) => this.onSettingsChange(e, 'searchParams'), value: state.get('searchParams') })))),
      ],
    ], h("section", { class: "settings--wide settings--extra settings--outline" }, (state.get('appType') === 'pesCatalog'
      || state.get('appType') === 'commerceConnector') && [
      !state.get('usePesRouter') && [
        h("section", { class: "settings--wide" }, h("label", null, "Country"), h("input", { type: "text", onChange: (e) => this.onSettingsChange(e, 'country'), value: state.get('country') })),
        h("section", { class: "settings--wide" }, h("label", null, "Language"), h("input", { type: "text", onChange: (e) => this.onSettingsChange(e, 'language'), value: state.get('language') })),
      ],
    ])), h("section", { class: "settings--wide settings--extra" }, state.get('appType') === 'pesCatalog' && [
      h("section", null, h("input", { type: "checkbox", onChange: (e) => this.onSettingsChange(e, 'showDocuments'), checked: state.get('showDocuments') }), h("label", null, "Show documents")),
      h("section", { class: "settings--wide" }, h("label", null, "DDC appSource:"), h("input", { type: "text", onChange: (e) => this.onSettingsChange(e, 'ddcAppSource'), value: state.get('ddcAppSource') })),
      h("section", null, h("input", { type: "checkbox", onChange: (e) => this.onSettingsChange(e, 'showCompare'), checked: state.get('showCompare') }), h("label", null, "Show compare control")),
      h("section", { class: "settings--wide" }, h("label", { title: "(all-products)" }, "DDC URL:"), h("input", { type: "text", onChange: (e) => this.onSettingsChange(e, 'ddcAllProductsUrl'), value: state.get('ddcAllProductsUrl') })),
      h("section", null, h("input", { type: "checkbox", onChange: (e) => this.onSettingsChange(e, 'showFaq'), checked: state.get('showFaq') }), h("label", null, "Show FAQ")),
      h("section", null, h("div", null, h("label", null, "Show buy online cta:")), h("pes-radio", { "group-id": "showBuyOnline", items: [
          { text: 'view details', value: 'false' },
          { text: 'show buy online', value: 'true' },
        ], onPesRadioChange: (e) => this.onSettingsChange(e, 'showBuyOnline'), "selected-value": state.get('showBuyOnline').toString() })),
      h("section", null, h("input", { type: "checkbox", onChange: (e) => this.onSettingsChange(e, 'showBreadcrumbs'), checked: state.get('showBreadcrumbs') }), h("label", null, "Show breadcrumbs")),
      h("section", null, h("label", null, "HTML dir:"), h("pes-radio", { "group-id": "dir", items: this.dirTypes, onPesRadioChange: (e) => this.onSettingsChange(e, 'dir'), "selected-value": state.get('dir') })),
      h("section", null, h("input", { type: "checkbox", onChange: (e) => this.onSettingsChange(e, 'showDiscountedPrice'), checked: state.get('showDiscountedPrice') }), h("label", null, "Show Discounted Price")),
      h("section", null, h("label", null, "Endpoint:"), h("input", { type: "text", onChange: (e) => this.onSettingsChange(e, 'endpoint'), value: state.get('endpoint') })),
      h("section", null, h("input", { type: "checkbox", onChange: (e) => this.onSettingsChange(e, 'showRecentlyViewed'), checked: state.get('showRecentlyViewed') }), h("label", null, "Show recently viewed")),
      h("section", null, h("label", null, "Site Type:"), h("select", { onChange: (e) => this.onSettingsChange(e, 'siteType') }, h("option", { selected: state.get('siteType') === 'b2b', value: "b2b" }, "B2B"), h("option", { selected: state.get('siteType') === 'b2c', value: "b2c" }, "B2C"))),
      state.get('usePesRouter') && (h("section", null, h("label", null, "base_dir:"), h("input", { type: "text", onChange: (e) => this.onSettingsChange(e, 'base_dir'), value: state.get('base_dir') }))),
    ], state.get('appType') === 'commerceConnector' && (h("div", null, h("section", null, h("label", null, "Products obj"), h("textarea", { rows: 10, cols: 50, onChange: (e) => this.onSettingsChange(e, 'products'), value: state.get('products') })), h("section", null, h("label", null, "Additional distributors obj"), h("textarea", { rows: 10, cols: 50, onChange: (e) => this.onSettingsChange(e, 'additionalDistributors'), value: state.get('additionalDistributors') })))), h("section", null, this.importExpanded ? (h("div", null, h("label", null, "Import / Export"), h("textarea", { onBlur: this.onImportChange }, getSettings()), h("button", { onClick: this.onImport, disabled: !this.importedSettings }, "Import"), h("button", { onClick: this.onImportToggle }, "Close"))) : (h("button", { onClick: this.onImportToggle }, "Import / Export settings"))))));
  }
  get el() { return getElement(this); }
};
ControlPanel.style = controlPanelCss;

export { AppPlayground as pes_app_test, CommerceConnectorItems as pes_cc_items, CommerceConnectorMain as pes_cc_main, CommerceConnectorView as pes_cc_main_view, CommerceConnectorNoResult as pes_cc_no_result, CommerceConnectorPrice as pes_cc_price, CommerceConnectorSearch as pes_cc_search, IconComponent as pes_icon, Notification as pes_notification, Preloader as pes_preloader, PesRadio as pes_radio, PesRadioGroup as pes_radio_button, ControlPanel as pes_settings_control_panel };
